export class SectionTab {
    constructor(public displayText: string,
        public index: number) {
    }
}
